var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"measurement-points-data-table-overview"},[_c('div',{staticClass:"overview-table-row"},[_c('div',{staticClass:"overview-table"},[_c('MeasurementObjectsTable',{attrs:{"projectId":_vm.$route.params.projectId,"projectCode":_vm.projectCode}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }